<h2 mat-dialog-title>Dettaglio utente – {{ user.username }}</h2>
<mat-dialog-content>
  <div class="mb-3">
    <div class="info-row"><span class="label">Nome:</span> <span class="value">{{ user.nome || '—' }}</span></div>
    <div class="info-row"><span class="label">Cognome:</span> <span class="value">{{ user.cognome || '—' }}</span></div>
    <div class="info-row"><span class="label">Email:</span> <span class="value">{{ user.email || '—' }}</span></div>
  </div>

  <h3 class="h6 mt-3 mb-2">Gruppi WSO2</h3>
  @if (loadingGroups) {
    <div class="d-flex align-items-center gap-2 py-2">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Caricamento gruppi...</span>
    </div>
  } @else if (errorGroups) {
    <p class="text-danger small mb-0">{{ errorGroups }}</p>
  } @else if (groups.length > 0) {
    <ul class="list-unstyled mb-0">
      @for (g of groups; track g.value) {
        <li>{{ g.display || g.value || '—' }}</li>
      }
    </ul>
  } @else {
    <p class="text-muted small mb-0">Nessun gruppo associato.</p>
  }

  <h3 class="h6 mt-4 mb-2">COT collegate</h3>
  @if (loadingCots) {
    <div class="d-flex align-items-center gap-2 py-2">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Caricamento COT...</span>
    </div>
  } @else if (errorCots) {
    <p class="text-danger small mb-0">{{ errorCots }}</p>
  } @else if (cots.length > 0) {
    <ul class="list-unstyled mb-0">
      @for (c of cots; track c.id) {
        <li>{{ c.codice }} – {{ c.descrizione || '—' }}</li>
      }
    </ul>
  } @else {
    <p class="text-muted small mb-0">Nessuna COT collegata.</p>
  }

  <h3 class="h6 mt-4 mb-2">Tipi segnalazione</h3>
  @if (loadingTipiSegnalazione) {
    <div class="d-flex align-items-center gap-2 py-2">
      <mat-spinner diameter="24"></mat-spinner>
      <span>Caricamento tipi segnalazione...</span>
    </div>
  } @else if (errorTipiSegnalazione) {
    <p class="text-danger small mb-0">{{ errorTipiSegnalazione }}</p>
  } @else if (tipiSegnalazione.length > 0) {
    <ul class="list-unstyled mb-0">
      @for (t of tipiSegnalazione; track t.id) {
        <li>{{ t.codice || '—' }} – {{ t.descrizione || '—' }}</li>
      }
    </ul>
  } @else {
    <p class="text-muted small mb-0">Nessun tipo segnalazione associato.</p>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>
